export const APP_QUERY_PARAM = "app";
export const APP_QUERY_VALUE = "1";
export const MOBILE_BREAKPOINT = 768;

export const MOBILE_APP_PATHS = [
  "/cart",
  "/checkout",
  "/login",
  "/register",
  "/search-location",
  "/my-location",
  "/my-addresses",
  "/my-cards",
  "/my-wallet",
  "/my-orders",
  "/my-account",
  "/alerts",
  "/explore",
];

const getWindow = () => (typeof window === "undefined" ? null : window);

export const isAppUrl = () => {
  const currentWindow = getWindow();
  if (!currentWindow) return false;

  return new URLSearchParams(currentWindow.location.search).get(APP_QUERY_PARAM) === APP_QUERY_VALUE;
};

export const isMobileViewport = () => {
  const currentWindow = getWindow();
  return Boolean(currentWindow && currentWindow.innerWidth <= MOBILE_BREAKPOINT);
};

export const isDesktopViewport = () => {
  const currentWindow = getWindow();
  return Boolean(currentWindow && currentWindow.innerWidth > MOBILE_BREAKPOINT);
};

export const isStandalonePwa = () => {
  const currentWindow = getWindow();
  if (!currentWindow) return false;

  return (
    currentWindow.matchMedia("(display-mode: standalone)").matches ||
    currentWindow.navigator.standalone === true
  );
};

export const isInsidePreviewFrame = () => {
  const currentWindow = getWindow();
  if (!currentWindow) return false;

  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    return true;
  }
};

export const isMobileAppRoute = () => {
  const currentWindow = getWindow();
  if (!currentWindow) return false;

  return MOBILE_APP_PATHS.some((path) => (
    currentWindow.location.pathname === path ||
    currentWindow.location.pathname.startsWith(`${path}/`)
  ));
};

export const isLoggedInUser = (user) => {
  if (user?.success === true) return true;

  try {
    const saved = JSON.parse(localStorage.getItem("state") || "{}");
    return saved?.user?.user?.success === true;
  } catch {
    return false;
  }
};

export const hasSelectedAddress = () => {
  const currentWindow = getWindow();
  return Boolean(currentWindow && currentWindow.localStorage.getItem("userSetAddress"));
};

export const shouldPreserveAppQuery = () => isAppUrl() || isInsidePreviewFrame();

export const getAppRouteSuffix = () => (shouldPreserveAppQuery() ? `?${APP_QUERY_PARAM}=${APP_QUERY_VALUE}` : "");

export const buildMobileAppUrl = ({ restaurant, itemId, path = "/" } = {}) => {
  const currentWindow = getWindow();
  const origin = currentWindow ? currentWindow.location.origin : "";
  const appPath = restaurant
    ? `/stores/${restaurant}${itemId ? `/${itemId}` : ""}`
    : path;

  return `${origin}${appPath}?${APP_QUERY_PARAM}=${APP_QUERY_VALUE}`;
};

export const shouldRedirectDesktopToLanding = () => (
  isDesktopViewport() && !isAppUrl() && !isInsidePreviewFrame()
);

export const shouldShowMobileApp = ({ user, mobileAlwaysUsesApp = false } = {}) => {
  const mobile = isMobileViewport();

  return (
    isAppUrl() ||
    isStandalonePwa() ||
    isInsidePreviewFrame() ||
    isMobileAppRoute() ||
    (mobileAlwaysUsesApp && mobile) ||
    (mobile && (isLoggedInUser(user) || hasSelectedAddress()))
  );
};
